(function () {
  /**
   * @ngdoc module
   * @name binky.core.organizations
   * @description defines organization and organization list models
   */
  angular.module('binky.core.organizations', [
    'binky.core.api.jil',
    'binky.core.common.list',
    'binky.core.common.model.cache',
    'binky.core.feature',
    'binky.core.lodash',
    'binky.core.src2-migration',
    'binky.core.storage-utils',
    'ngResource',
  ]);
})();
